import { useCallback, useMemo } from "react";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext.js";
import { useGTMEvent } from "../GoogleTagManager/googleTagManagerHooks";
import { LangChooserDropdown } from "./components/lang-chooser-dropdown/LangChooserDropdown";
import { LangChooserSlider } from "./components/lang-chooser-slider/LangChooserSlider";
import { LANG_CHOOSER_TYPES } from "./lang-chooser-constants";
import { LangChooserWrapperStyled, } from './styled/LangChooserStyled.js';

const getLangChooserComponentByType = (type) => {
    switch(type) {
        case LANG_CHOOSER_TYPES.slider:
            return LangChooserSlider;
        case LANG_CHOOSER_TYPES.dropdown:
        default:
            return LangChooserDropdown;
    }
}

export const LangChooser = ({
    className,
    isHideButtonName,
    isHideButtonArrowIcon,
    gtmModule,
    toggleButtonComponent,
    type = LANG_CHOOSER_TYPES.dropdown,
}) => {
    const { locale, setLocale, availableLocales } = useLangContext();
    const {handleGTMClick} = useGTMEvent(gtmModule ? { module: gtmModule } : {});
    const changeLang = useCallback((locale) => {
        setLocale(locale);
        handleGTMClick({ component: 'LangChooser', newLocale: locale })
    }, [handleGTMClick, setLocale]);

    const Component = useMemo(() => getLangChooserComponentByType(type), [type]);

    return <LangChooserWrapperStyled className={className}>
        <Component
            isHideButtonArrowIcon={isHideButtonArrowIcon}
            isHideButtonName={isHideButtonName}
            locales={availableLocales}
            locale={locale}
            onSelectLang={changeLang}
            toggleButtonComponent={toggleButtonComponent}
        />
    </LangChooserWrapperStyled>
}
